module.exports = __webpack_public_path__ + "img/Abiores.b62e3a31.webp";